import React from 'react'

const VerifiedBadge = () => {
  return (
    <>👑</>
  )
}

export default VerifiedBadge